var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useContext } from 'react';
import { AppUiContext } from './AppUiContext';
export const useAppUi = () => {
    _react_refresh_temp_1();
    const appUiContextValue = useContext(AppUiContext);
    if (!appUiContextValue) {
        throw new Error('AppUi context not available!');
    }
    return appUiContextValue;
};
_react_refresh_temp_1(useAppUi, "OMgj42ND13ouAQv7aCr7bxKL5Y4=");
